
export function dateToTimestamp(date) {
  if(!date) return ''
  if(typeof date == 'string') date = new Date(date)

  return Math.floor(date.getTime())
}

export function printFullDate(dateString) {
  const date = new Date(dateString)
  
  const day = date.getDate()
  const month = date.getMonth() + 1
  const year = date.getFullYear()
  const hours = date.getHours()
  const minutes = date.getMinutes()
  
  const formattedDay = day < 10 ? '0' + day : day
  const formattedMonth = month < 10 ? '0' + month : month
  const formattedHours = hours < 10 ? '0' + hours : hours
  const formattedMinutes = minutes < 10 ? '0' + minutes : minutes
  
  return `${formattedDay}.${formattedMonth}.${year}  ${formattedHours}:${formattedMinutes}`
}

export function printDate(dateString) {
  const date = new Date(dateString)
  
  const day = date.getDate()
  const month = date.getMonth() + 1
  const year = date.getFullYear()
  
  const formattedDay = day < 10 ? '0' + day : day
  const formattedMonth = month < 10 ? '0' + month : month
  
  return `${formattedDay}.${formattedMonth}.${year}`
}

export function printTime(dateString) {
  const date = new Date(dateString)
  
  const hours = date.getHours()
  const minutes = date.getMinutes()
  
  const formattedHours = hours < 10 ? '0' + hours : hours
  const formattedMinutes = minutes < 10 ? '0' + minutes : minutes
  
  return `${formattedHours}:${formattedMinutes}`
}
